import { render, staticRenderFns } from "./RosterError.vue?vue&type=template&id=0d946e07&scoped=true&"
import script from "./RosterError.vue?vue&type=script&lang=js&"
export * from "./RosterError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d946e07",
  null
  
)

export default component.exports